import { Controller } from "@hotwired/stimulus"

// File input wrapper supporting click-to-pick AND HTML5 drag-drop, with
// inline image preview and an optional purge flag for ActiveStorage
// attachments. Wire on a wrapping div:
//   data-controller="image-dropzone"
//   data-image-dropzone-target="dropzone"
//   data-action="click->image-dropzone#openPicker dragover->image-dropzone#dragover dragleave->image-dropzone#dragleave drop->image-dropzone#drop"
// Children:
//   <input type="file" accept="image/*" hidden data-image-dropzone-target="input" data-action="change->image-dropzone#changed">
//   <img data-image-dropzone-target="preview" hidden>
//   <span data-image-dropzone-target="placeholder">…</span>  (optional)
//   <input type="hidden" name="…[remove_cover_image]" value="0" data-image-dropzone-target="removeFlag">  (optional)
export default class extends Controller {
  static targets = ["input", "preview", "dropzone", "placeholder", "removeFlag"]

  openPicker(event) {
    if (event.target.tagName === "INPUT" || event.target.tagName === "BUTTON")
      return
    this.inputTarget.click()
  }

  dragover(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.add("ring-vivid-purple")
  }

  dragleave() {
    this.dropzoneTarget.classList.remove("ring-vivid-purple")
  }

  drop(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.remove("ring-vivid-purple")
    const dt = new DataTransfer()
    Array.from(event.dataTransfer.files).forEach((f) => dt.items.add(f))
    this.inputTarget.files = dt.files
    if (this.hasRemoveFlagTarget) this.removeFlagTarget.value = "0"
    this.changed()
  }

  changed() {
    const file = this.inputTarget.files[0]
    if (!file) {
      this.previewTarget.hidden = true
      if (this.hasPlaceholderTarget) this.placeholderTarget.hidden = false
      return
    }
    if (this.hasRemoveFlagTarget) this.removeFlagTarget.value = "0"
    const reader = new FileReader()
    reader.onload = () => {
      this.previewTarget.src = reader.result
      this.previewTarget.hidden = false
      if (this.hasPlaceholderTarget) this.placeholderTarget.hidden = true
    }
    reader.readAsDataURL(file)
  }

  // Marks the attachment for removal on save and clears the preview.
  // Wire on a trash button: data-action="click->image-dropzone#clear"
  clear(event) {
    event?.preventDefault()
    event?.stopPropagation()
    this.inputTarget.value = ""
    this.previewTarget.hidden = true
    this.previewTarget.removeAttribute("src")
    if (this.hasPlaceholderTarget) this.placeholderTarget.hidden = false
    if (this.hasRemoveFlagTarget) this.removeFlagTarget.value = "1"
  }
}
